import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../services/setupInterceptors";

const initialState = {
  user: null,
  status: "idle",
  error: null,
};

export const fetchCurrentUser = createAsyncThunk(
  "user/fetchMe",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosClient.get("/users/fetch/me");
      return data?.success ? data.data : rejectWithValue("Error fetching user");
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error fetching user"
      );
    }
  }
);

export const updateUserDetails = createAsyncThunk(
  "user/updateDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosClient.patch("/users/", payload);
      return data?.success ? data.data : rejectWithValue("Error updating user");
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error updating user"
      );
    }
  }
);

export const updateNotificationPreferences = createAsyncThunk(
  "user/updateNotifications",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosClient.patch("/users/notification-settings", payload);
      return data?.success
        ? data.data
        : rejectWithValue("Error updating notifications");
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error updating notifications"
      );
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.status = "idle";
      state.error = null;
    },
    resetStatus: (state) => {
      state.status = "idle";
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Current User
      .addCase(fetchCurrentUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
        state.error = null;
      })
      .addCase(fetchCurrentUser.rejected, (state, action) => {
        state.status = "failed";
        state.user = null;
        state.error = action.payload;
      })

    //   .addCase(updateUserDetails.pending, (state) => {
    //     state.status = "loading";
    //     state.error = null;
    //   })
      .addCase(updateUserDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (state.user) {
          state.user = { 
            ...state.user, 
            ...action.payload,
           
            notification_settings: action.payload.notification_settings || state.user.notification_settings,
            addresses: action.payload.addresses || state.user.addresses,
            stats: action.payload.stats || state.user.stats,
          };
        }
      })
      .addCase(updateUserDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

    //   .addCase(updateNotificationPreferences.pending, (state) => {
    //     state.status = "loading";
    //     state.error = null;
    //   })
      .addCase(updateNotificationPreferences.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (state.user) {
          state.user.notification_settings = {
            ...state.user.notification_settings,
            ...action.payload,
          };
        }
      })
      .addCase(updateNotificationPreferences.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { logout, resetStatus } = userSlice.actions;
export default userSlice.reducer;